export default class Int {
  static name = 'Int'

  static parse (value) {
    if (_.isString(value)) {
      return Number.parseInt(value)
    } else {
      return value
    }
  }
}
